<h2 *ngIf="person && person.name" class="first_title">Dettagli persona {{person.name}}</h2>
<h2 *ngIf="person && person.firstName && person.lastName" class="first_title">Dettagli persona {{person.firstName}}
  {{person.lastName}}</h2>
<app-pathbar-lem [pathbars]="pathbars"></app-pathbar-lem>
<div export-help></div>
<div class="content-page-wrapper">
  <div class="standardpanel">
    <div class="titleblock mb-25">
      <h3 class="title1level mt-0">
        Persona
      </h3>
    </div>
  
    <div *ngIf="person && person.firstName">
      <div class="row">
        <div class="col-sm-4">
          <label for="name">Nome</label>
          <input class="form-control" disabled="" type="text" name="name" autocomplete="name" placeholder="inserire nome" [value]="person.firstName">
        </div>
        <div class="col-sm-4"> <label for="companyType-lastname">Cognome</label>
          <input id="companyType-lastname" class="form-control" disabled="" type="text" name="lastname" autocomplete="family-name" placeholder="inserire cognome" [value]="person.lastName">
        </div>
        <div class="col-sm-4">
          <label for="companyScope">Tipo Persona</label>
          <input id="companyScope" class="form-control" disabled="" type="text" name="type" placeholder="inserire tipo persona" [value]="getTypeValue(person.type)">
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <label for="cod-fiscale">Codice Fiscale</label>
          <input id="cod-fiscale" class="form-control" disabled="" type="text" name="taxnumber" placeholder="inserire codice fiscale" [value]="person.taxNumber">
        </div>
        <div class="col-sm-6"> <label for="companyType-email">Email</label>
          <input id="companyType-email" class="form-control" disabled="" type="text" name="email" autocomplete="email" placeholder="inserire email" [value]="person.email">
        </div>
      </div>
    </div>
    <div *ngIf="person && person.name">
      <div class="row">
        <div class="col-sm-6">
          <label for="name-lbl">Name</label>
          <input id="name-lbl" class="form-control" disabled="" type="text" name="taxnumber" placeholder="inserire nome" [value]="person.name">
        </div>
        <div class="col-sm-6"> <label for="companyType-tipo-persona">Tipo Persona</label>
          <input id="companyType-tipo-persona" class="form-control" disabled="" type="text" name="email" autocomplete="email" placeholder="inserire tipo persona" [value]="getTypeValue(person.type)">
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <label for="c-fisc-lbl">Codice Fiscale</label>
          <input id="c-fisc-lbl" class="form-control" disabled="" type="text" name="taxnumber" placeholder="inserire codice fiscale" [value]="person.taxNumber">
        </div>
        <div class="col-sm-6"> <label for="companyType-p-iva">Partita IVA</label>
          <input id="companyType-p-iva" class="form-control" disabled="" type="text" name="partita-iva" placeholder="inserire partita IVA" [value]="person.vatNumber">
        </div>
      </div>
    </div>
  
  </div>
</div>
